import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import ProgressBar from '../../../../components/progress-bar';
import Fa from 'react-fontawesome';

import ForecastTable from '../forecast-table/forecast-table';
import OpportunityTable from '../opportunity-table/opportunity-table';
import { Element, scroller } from 'react-scroll';
import { delay } from 'lodash';
import { Tab, Tabs, Tooltip, OverlayTrigger } from 'react-bootstrap';
import NumberDisplay from '../../../../components/number-display';

// Import Actions
import { fetchOpportunities, reset } from '../../ForecastActions';

// Import Selectors
import { getLoading, getLoaded, getErrors, getHasErrors, getPeriodRange,
  getForcasts, getBeginningStats,
  getLostOpportunities, getLostStats,
  getWonOpportunities, getWonStats,
  getSlippedOpportunities, getSlippedStats,
  getNoDecisionOpportunities, getNoDecisionStats,
  getClosedOpportunities, getClosedStats,
  getForecastId,
  getNewOpportunities, getNewStats } from '../../ForecastReducer';


const TABLE_NAME = 'forecast-history-table';

class HistoryDetail extends Component {
  constructor(args) {
    super(args);
    this.state = {
      selectedDealType: null,
      selectedForecastType: 'beginning',
    };
    this.handleTabSelect = this.handleTabSelect.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    const currentStart = this.props.start;
    const currentEnd = this.props.end;
    const newStart = nextProps.start;
    const newEnd = nextProps.end;
    const { query, team } = nextProps;
    if (newStart && newStart) {
      if (!newStart.isSame(currentStart, 'day') || !newEnd.isSame(currentEnd, 'day')) {
        this.props.dispatch(reset());
        const params = {
          forecast: true,
          period: [newStart.format('YYYY-MM-DD'), newEnd.format('YYYY-MM-DD')],
          isHistory: true,
          query,
          team,
        };
        this.props.dispatch(fetchOpportunities(params));
        this.setState({ selectedForecastType: 'beginning' });
      }
    } else if (currentStart && currentEnd) {
      this.props.dispatch(reset());
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleTabSelect(selectedForecastType) {
    this.setState({ selectedForecastType });
  }

  scrollToDetail() {
    delay(
      () => {
        scroller.scrollTo('dealTable', { duration: 500, smooth: true, offset: -70 });
      },
      1000,
    );
  }
  renderError() {
    const { errors, hasErrors } = this.props;
    if (!hasErrors) {
      return null;
    }
    let message = errors.messge;
    if (errors.data) {
      message = errors.data.message || errors.data;
    }
    return (
      <div className="container">
        <div className="alert alert-danger">
          <Fa name="exclamation-triangle" /> {message}
        </div>
      </div>
    );
  }


  render() {
    const {
      loading, loaded, hasErrors, dropdown,
      beginningStats,
      wonOpportunities, wonStats,
      slippedOpportunities, slippedStats,
      newOpportunities, newStats,
      lostOpportunities, lostStats,
      noDecisionOpportunities, noDecisionStats,
      forecasts, forecastId,
      periodRange,
    } = this.props;
    const { selectedDealType, selectedForecastType } = this.state;

    const beginningTooltip = (<Tooltip id="beginning-tooltip">
      Opportunities originally forecast to close for the {periodRange} forecast period.
    </Tooltip>);
    const wonTooltip = (<Tooltip id="won-tooltip">
      Opportunities won in the {periodRange} forecast period.
    </Tooltip>);
    const slippedTooltip = (<Tooltip id="slipped-tooltip">
      Opportunities originally forecast to close in the {periodRange} forecast period, but now have close dates that fall after the end of this forecast period.
    </Tooltip>);
    const lostTooltip = (<Tooltip id="lost-tooltip">
      Opportunities lost in the {periodRange} forecast period.
    </Tooltip>);
    const newTooltip = (<Tooltip id="new-tooltip">
      New opportunities added to the {periodRange} forecast period after the period began.
    </Tooltip>);
    const noDecisionTooltip = (<Tooltip id="no-decision-tooltip">
      Opportunities closed as no decisions in the {periodRange} forecast period.
    </Tooltip>);

    return (
      <div>
        {loading && <div className="container"><ProgressBar /></div>}
        {!loading && loaded && <div>
          <div className="container">
            <h5 className="sub-header-with-controls">{dropdown} Forecast Period Detail</h5>
          </div>
          <ForecastTable
            isHistory
            selectedForecastType={selectedForecastType}
            onCellClick={(opt) => {
              this.setState({
                selectedDealType: opt.dealType || null,
                selectedForecastType: opt.forecastType || null,
              });
              this.scrollToDetail();
            }}
          />
          <div className="container">
            <Element name="dealTable" />
            <div>
              <p />
              <Tabs
                activeKey={selectedForecastType}
                onSelect={this.handleTabSelect}
                animation={false}
                id="forecast-tab"
                mountOnEnter
                unmountOnExit
              >
                <Tab
                  eventKey="beginning"
                  title={
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={beginningTooltip}>
                      <span>
                        Beginning
                        {forecasts.length ? <span>&nbsp;<span className="badge">
                          <NumberDisplay value={forecasts.length} precision={0} />
                        </span>
                        </span> : null}
                      </span>
                    </OverlayTrigger>
                  }
                >
                  <OpportunityTable
                    showSalesStage
                    isBeginning
                    stats={beginningStats}
                    opportunities={forecasts}
                    dealType={selectedDealType}
                    forecastId={forecastId}
                    showTypeChart
                    showSizeChart
                    showCycleChart
                    tableName={TABLE_NAME}
                  />
                </Tab>

                {wonOpportunities.length > 0 && <Tab
                  eventKey="won"
                  title={
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={wonTooltip}>
                      <span>
                        Won
                        {wonOpportunities.length ? <span>&nbsp;<span className="badge">
                          <NumberDisplay value={wonOpportunities.length} precision={0} />
                        </span>
                        </span> : null}
                      </span>
                    </OverlayTrigger>
                  }
                >
                  <OpportunityTable
                    showStage
                    stats={wonStats}
                    opportunities={wonOpportunities}
                    dealType={selectedDealType}
                    forecastId={forecastId}
                    showTypeChart
                    showSizeChart
                    showCycleChart
                    tableName={TABLE_NAME}
                  />
                </Tab>}

                {newOpportunities.length > 0 && <Tab
                  eventKey="new"
                  title={
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={newTooltip}>
                      <span>
                        New
                        {newOpportunities.length ? <span>&nbsp;<span className="badge">
                          <NumberDisplay value={newOpportunities.length} precision={0} />
                        </span>
                        </span> : null}
                      </span>
                    </OverlayTrigger>
                  }
                >
                  <OpportunityTable
                    showStage
                    stats={newStats}
                    opportunities={newOpportunities}
                    dealType={selectedDealType}
                    forecastId={forecastId}
                    showTypeChart
                    showSizeChart
                    showCycleChart
                    tableName={TABLE_NAME}
                  />
                </Tab>}

                {slippedOpportunities.length > 0 && <Tab
                  eventKey="slipped"
                  title={
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={slippedTooltip}>
                      <span>
                        Slipped
                        {slippedOpportunities.length ? <span>&nbsp;<span className="badge">
                          <NumberDisplay value={slippedOpportunities.length} precision={0} />
                        </span>
                        </span> : null}
                      </span>
                    </OverlayTrigger>
                  }
                >
                  <OpportunityTable
                    showSalesStage
                    stats={slippedStats}
                    opportunities={slippedOpportunities}
                    dealType={selectedDealType}
                    forecastId={forecastId}
                    showTypeChart
                    showSizeChart
                    showCycleChart
                    tableName={TABLE_NAME}
                  />
                </Tab>}

                {lostOpportunities.length > 0 && <Tab
                  eventKey="lost"
                  title={
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={lostTooltip}>
                      <span>
                        Lost
                        {lostOpportunities.length ? <span>&nbsp;<span className="badge">
                          <NumberDisplay value={lostOpportunities.length} precision={0} />
                        </span>
                        </span> : null}
                      </span>
                    </OverlayTrigger>
                  }
                >
                  <OpportunityTable
                    showStage
                    stats={lostStats}
                    opportunities={lostOpportunities}
                    dealType={selectedDealType}
                    forecastId={forecastId}
                    showTypeChart
                    showSizeChart
                    showCycleChart
                    tableName={TABLE_NAME}
                  />
                </Tab>}

                {noDecisionOpportunities.length > 0 && <Tab
                  eventKey="noDecision"
                  title={
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={noDecisionTooltip}>
                      <span>
                        No Decision
                        {noDecisionOpportunities.length ? <span>&nbsp;<span className="badge">
                          <NumberDisplay value={noDecisionOpportunities.length} precision={0} />
                        </span>
                        </span> : null}
                      </span>
                    </OverlayTrigger>
                  }
                >
                  <OpportunityTable
                    showStage
                    stats={noDecisionStats}
                    opportunities={noDecisionOpportunities}
                    dealType={selectedDealType}
                    forecastId={forecastId}
                    showTypeChart
                    showSizeChart
                    showCycleChart
                    tableName={TABLE_NAME}
                  />
                </Tab>}

              </Tabs>
            </div>
          </div>
        </div>}
        {!loading && hasErrors && this.renderError()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    forecasts: getForcasts(state),
    loading: getLoading(state),
    loaded: getLoaded(state),
    errors: getErrors(state),
    hasErrors: getHasErrors(state),

    beginningStats: getBeginningStats(state),

    wonOpportunities: getWonOpportunities(state),
    wonStats: getWonStats(state),

    slippedOpportunities: getSlippedOpportunities(state),
    slippedStats: getSlippedStats(state),

    newOpportunities: getNewOpportunities(state),
    newStats: getNewStats(state),

    lostOpportunities: getLostOpportunities(state),
    lostStats: getLostStats(state),

    noDecisionOpportunities: getNoDecisionOpportunities(state),
    noDecisionStats: getNoDecisionStats(state),

    closedOpportunities: getClosedOpportunities(state),
    closedStats: getClosedStats(state),

    periodRange: getPeriodRange(state),
    forecastId: getForecastId(state),
  };
}

HistoryDetail.propTypes = {
  forecasts: PropTypes.arrayOf([]).isRequired,
  team: PropTypes.shape({}),
  beginningStats: PropTypes.shape({}).isRequired,
  wonOpportunities: PropTypes.arrayOf([]).isRequired,
  wonStats: PropTypes.shape({}).isRequired,
  slippedOpportunities: PropTypes.arrayOf([]).isRequired,
  slippedStats: PropTypes.shape({}).isRequired,
  newOpportunities: PropTypes.arrayOf([]).isRequired,
  newStats: PropTypes.shape({}).isRequired,
  lostOpportunities: PropTypes.arrayOf([]),
  lostStats: PropTypes.shape({}).isRequired,

  noDecisionOpportunities: PropTypes.arrayOf([]),
  noDecisionStats: PropTypes.shape({}).isRequired,

  closedOpportunities: PropTypes.arrayOf([]),
  closedStats: PropTypes.shape({}).isRequired,

  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
  errors: PropTypes.shape({}),
  dispatch: PropTypes.func.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  start: PropTypes.instanceOf(moment),
  end: PropTypes.instanceOf(moment),
  query: PropTypes.shape({}),
  dropdown: PropTypes.node,
  periodRange: PropTypes.string.isRequired,
  forecastId: PropTypes.string,
};


HistoryDetail.defaultProps = {
  team: null,
  lostOpportunities: [],
  noDecisionOpportunities: [],
  closedOpportunities: [],
  errors: {},
  start: null,
  end: null,
  query: {},
  dropdown: null,
  forecastId: null,
};

export default connect(mapStateToProps)(HistoryDetail);
